export const mskEuOptions = [
  {
    value: 'doctor_recommendation',
    name: 'eu__signup__hdyhau__doctor_recommendation',
  },
  { value: 'family_friends', name: 'eu__signup__hdyhau__family_friends' },
  { value: 'meta_ads', name: 'eu__signup__hdyhau__social_media' },
  { value: 'other', name: 'eu__signup__hdyhau__other' },
]

export default [
  { value: 'social_media', name: 'eu__signup__hdyhau__social_media' },
  { value: 'blog_post', name: 'eu__signup__hdyhau__blog_post' },
  { value: 'family_friends', name: 'eu__signup__hdyhau__family_friends' },
  {
    value: 'doctor_recommendation',
    name: 'eu__signup__hdyhau__doctor_recommendation',
  },
  { value: 'teleclinic', name: 'eu__signup__hdyhau__teleclinic' },
  { value: 'search_engine', name: 'eu__signup__hdyhau__search_engine' },
  { value: 'press', name: 'eu__signup__hdyhau__press' },
  { value: 'audio_ad', name: 'eu__signup__hdyhau__audio_ad' },
  { value: 'tv', name: 'eu__signup__hdyhau__tv' },
  { value: 'app_store', name: 'eu__signup__hdyhau__app_store' },
  { value: 'other', name: 'eu__signup__hdyhau__other' },
]
